import { ComponentRendering, Field, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { sanitize } from 'isomorphic-dompurify';

import { ComponentProps, resolveColorProperty } from '@gn-audio/jss-components';

type WidgetEmbedFields = {
  backgroundColor: Field<string>;
  isFullWidth: Field<boolean>;
  html: Field<string>;
  allowedHtmlTags: Field<string>;
  allowedHtmlAttributes: Field<string>;
};

export type WidgetEmbedProps = ComponentProps & {
  fields: WidgetEmbedFields;
  sanitizedHtml?: string;
};

const parseCommaSeparatedAllowList = (value?: string | null): string[] => {
  if (!value) return [];

  return value
    .split(',')
    .map((entry) => entry.trim().toLowerCase())
    .filter(Boolean);
};

const WidgetEmbed = ({ fields, sanitizedHtml }: WidgetEmbedProps) => {
  const backgroundColor = fields?.backgroundColor?.value;
  const contentContainerClass = fields?.isFullWidth?.value
    ? 'container'
    : 'container flex max-w-6xl justify-center';

  if (!sanitizedHtml || sanitizedHtml === '') return null;
  const backgroundColorHex = resolveColorProperty(backgroundColor);

  return (
    <div style={{ backgroundColor: backgroundColorHex }}>
      <div
        className={contentContainerClass}
        dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
      ></div>
    </div>
  );
};

export const getStaticProps = async ({ fields }: ComponentRendering<WidgetEmbedFields>) => {
  try {
    const html = fields?.html?.value;
    if (!html) return {};

    return {
      sanitizedHtml: sanitize(html, {
        ADD_TAGS: parseCommaSeparatedAllowList(fields?.allowedHtmlTags?.value),
        ADD_ATTR: parseCommaSeparatedAllowList(fields?.allowedHtmlAttributes?.value),
      }),
    };
  } catch (error) {
    console.error('Error in WidgetEmbed getStaticProps:', error);
    return {};
  }
};

export default withDatasourceCheck()<WidgetEmbedProps>(WidgetEmbed);
